import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlay } from '@fortawesome/pro-regular-svg-icons/faCirclePlay';

import React from 'react';
import PropTypes from 'prop-types';

import { Text, TextType } from 'ui-components/components/text';
import { Button } from 'ui-components/components/button';

import style from './engagement-card.module.less';
import { messages } from './messages';

export const VideoButton = ({ onVideoClicked, videoId }) => {
  const videoUrl = `https://shipstation.wistia.com/medias/${videoId}`;
  return (
    <Button className={style['action-button']} href={videoUrl} onClick={onVideoClicked} theme='tertiary'>
      <FontAwesomeIcon className={style['circle-play-icon']} icon={faCirclePlay} />
      <Text textType={TextType.Paragraph} value={messages.tutorial} />
    </Button>
  );
};

VideoButton.propTypes = {
  onVideoClicked: PropTypes.func.isRequired,
  videoId: PropTypes.string.isRequired,
};
